// @ts-nocheck

import { createSelector } from 'reselect';

import { selectMatchNbTMM } from '../../selectors/match.selector';

const selectMatchTopMyMatchProps = createSelector([selectMatchNbTMM], (nbTMM) => ({
  nbTMM,
}));

export default selectMatchTopMyMatchProps;
